module.exports = __webpack_public_path__ + "img/9.cb4a7e8b.jpg";